(function () {
  'use strict';

  angular.module('imnApp').controller('RelatorioSchedulerController', RelatorioSchedulerController);

  RelatorioSchedulerController.$inject = ['$interval', 'RelatorioService'];

  function RelatorioSchedulerController($interval, RelatorioService) {
    var vm = this;
    var timer = null;
    vm.abreModal = abreModal;
    vm.fecharModal = fecharModal;
    vm.modalAberta = false;
    vm.sincronizar = sincronizar;

    function abreModal(olt) {
      $interval.cancel(timer);
      vm.oltSelecionada = olt;
      vm.modalAberta = true;
      buscaInformacoesDaOlt();
      recarregaAsInformacoesDaModalDeTemposEmTempos();
    }

    function carregaDadosDaApi(data) {
      /*var dataDeSolicitacaoDoProcessamentoForcado = data.dataDeSolicitacaoDoProcessamentoForcado
             var dataInicioUltimoProcessamento = data.dataInicioUltimoProcessamento
             var dataFinalUltimoProcessamento = data.dataFinalUltimoProcessamento
             var aindaNaoComecouSincronizacaoForcada = dataDeSolicitacaoDoProcessamentoForcado > dataInicioUltimoProcessamento
             var oSchedulerJaComecou = dataDeSolicitacaoDoProcessamentoForcado < dataInicioUltimoProcessamento
             var dataFinalEhValida = dataFinalUltimoProcessamento != null && dataFinalUltimoProcessamento > dataInicioUltimoProcessamento
             var oSchedulerJaTerminou = dataFinalEhValida && oSchedulerJaComecou
             vm.aindaNaoComecouSincronizacaoForcada = aindaNaoComecouSincronizacaoForcada
             vm.oSchedulerJaComecou = oSchedulerJaComecou
             vm.oSchedulerJaTerminou = oSchedulerJaTerminou*/
      var onuReports = data.onuReports;
      var bridgeReports = data.bridgeReports;
      vm.servicosRemovidos = bridgeReports;
      vm.onusRemovidas = onuReports;
    }
    function fecharModal() {
      vm.modalAberta = false;
      paraDeRecarregarAsInformacoesDaModal();
    }
    function recarregaAsInformacoesDaModalDeTemposEmTempos() {
      timer = $interval(buscaInformacoesDaOlt, 5000);
    }
    function buscaInformacoesDaOlt() {
      if (vm.oltSelecionada) RelatorioService.informacoesRelatorioDaOlt(vm.oltSelecionada).then(carregaDadosDaApi);
      else fecharModal();
    }
    function paraDeRecarregarAsInformacoesDaModal() {
      $interval.cancel(timer);
    }
    function sincronizar(olt) {
      vm.oltSelecionada = olt;
      RelatorioService.sincronizacaoForcada(vm.oltSelecionada);
    }
  }
})();
